import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { Add, Delete, ExpandMore } from '@mui/icons-material';
import { FormattedMessage, injectIntl } from 'react-intl';
import { getAllByHirerId } from '../../services/priority.service';
import { getByContext } from '../../services/sla-priority.service';
import SimpleSelectWithColor from '../select/simple-with-color';

class SlaPriorityConfig extends Component {
  constructor(props) {
    super(props);

    this.state = {
      priorities: [],
      loadingPriorities: false,

      items: [],

      selectedPriorityId: 0,
      newServiceTime: '',
      newSolutionTime: '',

      confirmDeleteId: null,
      expanded: true,
    };

    this.handleAdd = this.handleAdd.bind(this);
    this.handlePriorityChange = this.handlePriorityChange.bind(this);
    this.handleRequestDelete = this.handleRequestDelete.bind(this);
    this.handleConfirmDelete = this.handleConfirmDelete.bind(this);
    this.handleItemChange = this.handleItemChange.bind(this);
  }

  async componentDidMount() {
    this.setState({ loadingPriorities: true });
    const result = await getAllByHirerId();
    if (result && result.data) {
      const priorities = result.data || [];
      const { parentId, slaMode, defaultServiceTime, defaultSolutionTime, fallbackParentId, fallbackSlaMode } = this.props;

      let items;
      if (parentId) {
        const existing = await getByContext(slaMode, parentId);
        if (existing && existing.data && existing.data.length > 0) {
          items = existing.data.map(i => ({
            priorityid: i.priorityid,
            priorityname: i.priorityname,
            prioritycolorhex: i.prioritycolorhex || null,
            servicetime: i.servicetime != null ? String(i.servicetime) : '',
            solutiontime: i.solutiontime != null ? String(i.solutiontime) : '',
            slamode: slaMode,
          }));
        } else if (fallbackParentId && fallbackSlaMode) {
          // Sem configuração própria: herdar do OrgSLA pai
          const fallback = await getByContext(fallbackSlaMode, fallbackParentId);
          if (fallback && fallback.data && fallback.data.length > 0) {
            items = fallback.data.map(i => ({
              priorityid: i.priorityid,
              priorityname: i.priorityname,
              prioritycolorhex: i.prioritycolorhex || null,
              servicetime: i.servicetime != null ? String(i.servicetime) : '',
              solutiontime: i.solutiontime != null ? String(i.solutiontime) : '',
              slamode: slaMode,
            }));
          } else {
            items = priorities.map(p => ({
              priorityid: p.id,
              priorityname: p.name,
              prioritycolorhex: p.colorhex || null,
              servicetime: defaultServiceTime != null && defaultServiceTime !== '' ? String(defaultServiceTime) : '',
              solutiontime: defaultSolutionTime != null && defaultSolutionTime !== '' ? String(defaultSolutionTime) : '',
              slamode: slaMode,
            }));
          }
        } else {
          items = priorities.map(p => ({
            priorityid: p.id,
            priorityname: p.name,
            prioritycolorhex: p.colorhex || null,
            servicetime: defaultServiceTime != null && defaultServiceTime !== '' ? String(defaultServiceTime) : '',
            solutiontime: defaultSolutionTime != null && defaultSolutionTime !== '' ? String(defaultSolutionTime) : '',
            slamode: slaMode,
          }));
        }
      } else if (fallbackParentId && fallbackSlaMode) {
        // Novo item sem parentId: herdar do OrgSLA pai
        const fallback = await getByContext(fallbackSlaMode, fallbackParentId);
        if (fallback && fallback.data && fallback.data.length > 0) {
          items = fallback.data.map(i => ({
            priorityid: i.priorityid,
            priorityname: i.priorityname,
            prioritycolorhex: i.prioritycolorhex || null,
            servicetime: i.servicetime != null ? String(i.servicetime) : '',
            solutiontime: i.solutiontime != null ? String(i.solutiontime) : '',
            slamode: slaMode,
          }));
        } else {
          items = priorities.map(p => ({
            priorityid: p.id,
            priorityname: p.name,
            prioritycolorhex: p.colorhex || null,
            servicetime: defaultServiceTime != null && defaultServiceTime !== '' ? String(defaultServiceTime) : '',
            solutiontime: defaultSolutionTime != null && defaultSolutionTime !== '' ? String(defaultSolutionTime) : '',
            slamode: slaMode,
          }));
        }
      } else {
        items = priorities.map(p => ({
          priorityid: p.id,
          priorityname: p.name,
          prioritycolorhex: p.colorhex || null,
          servicetime: defaultServiceTime != null && defaultServiceTime !== '' ? String(defaultServiceTime) : '',
          solutiontime: defaultSolutionTime != null && defaultSolutionTime !== '' ? String(defaultSolutionTime) : '',
          slamode: slaMode,
        }));
      }

      this.setState({ priorities, items, loadingPriorities: false });
      this.notifyParent(items);
    } else {
      this.setState({ loadingPriorities: false });
    }
  }

  notifyParent(items) {
    if (!this.props.onItemsChange) return;
    const filled = items.filter(i => i.servicetime !== '' && i.solutiontime !== '');
    this.props.onItemsChange(
      filled.map(i => ({
        ...i,
        servicetime: parseInt(i.servicetime, 10),
        solutiontime: parseInt(i.solutiontime, 10),
      }))
    );
  }

  handleItemChange(priorityId, field, value) {
    const updated = this.state.items.map(i =>
      i.priorityid === priorityId ? { ...i, [field]: value } : i
    );
    this.setState({ items: updated });
    this.notifyParent(updated);
  }

  handlePriorityChange(stateName, value) {
    const { defaultServiceTime, defaultSolutionTime } = this.props;
    this.setState({
      selectedPriorityId: value,
      newServiceTime: defaultServiceTime != null && defaultServiceTime !== '' ? String(defaultServiceTime) : '',
      newSolutionTime: defaultSolutionTime != null && defaultSolutionTime !== '' ? String(defaultSolutionTime) : '',
    });
  }

  handleAdd() {
    const { selectedPriorityId, newServiceTime, newSolutionTime, items, priorities } = this.state;

    if (!selectedPriorityId || selectedPriorityId === 0) return;

    const priority = priorities.find(p => p.id === selectedPriorityId);
    if (!priority) return;

    const updated = [
      ...items,
      {
        priorityid: priority.id,
        priorityname: priority.name,
        prioritycolorhex: priority.colorhex || null,
        servicetime: newServiceTime,
        solutiontime: newSolutionTime,
        slamode: this.props.slaMode,
      },
    ];

    this.setState({
      items: updated,
      selectedPriorityId: 0,
      newServiceTime: '',
      newSolutionTime: '',
    });
    this.notifyParent(updated);
  }

  handleRequestDelete(priorityId) {
    this.setState({ confirmDeleteId: priorityId });
  }

  handleConfirmDelete() {
    const updated = this.state.items.filter(i => i.priorityid !== this.state.confirmDeleteId);
    this.setState({ items: updated, confirmDeleteId: null });
    this.notifyParent(updated);
  }

  render() {
    const { intl } = this.props;
    const { priorities, loadingPriorities, items, selectedPriorityId, newServiceTime, newSolutionTime, confirmDeleteId, expanded } = this.state;

    const usedIds = new Set(items.map(i => i.priorityid));
    const availablePriorities = priorities.filter(p => !usedIds.has(p.id));
    const hasAvailable = availablePriorities.length > 0;

    const canAdd = selectedPriorityId > 0 && newServiceTime !== '' && newSolutionTime !== '';

    const labelService = intl.formatMessage({ id: 'sla.service', defaultMessage: 'SLA Atendimento' }) + ' (min)';
    const labelSolution = intl.formatMessage({ id: 'sla.solution', defaultMessage: 'SLA Solução' }) + ' (min)';

    const itemToDelete = items.find(i => i.priorityid === confirmDeleteId);

    return (
      <>
        <Accordion
          expanded={expanded}
          onChange={() => this.setState({ expanded: !expanded })}
          variant="outlined"
          sx={{ mt: 1 }}
        >
          <AccordionSummary expandIcon={<ExpandMore />} sx={{ backgroundColor: 'grey.50' }}>
            <Box>
              <Typography variant="subtitle1" fontWeight={600}>
                <FormattedMessage id="sla.priority.config.title" defaultMessage="SLA por Prioridade" />
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <FormattedMessage
                  id="sla.priority.config.subtitle"
                  defaultMessage="Campos vazios herdam o SLA padrão definido acima"
                />
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails sx={{ p: 0 }}>
          <Box sx={{ px: 3, pt: 0, pb: 1 }}>
            <Alert severity="info" sx={{ fontSize: '0.8rem' }}>
              <FormattedMessage
                id="sla.priority.config.info"
                defaultMessage="Prioridades sem valores definidos utilizarão automaticamente o SLA padrão configurado acima."
              />
            </Alert>
          </Box>

          <Divider />

          {loadingPriorities ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 3, py: 3 }}>
              <CircularProgress size={20} />
              <Typography variant="body2" color="text.secondary">
                <FormattedMessage id="loading" defaultMessage="Carregando..." />
              </Typography>
            </Box>
          ) : (
            <>
              {items.length > 0 && (
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: 'grey.50' }}>
                        <TableCell sx={{ fontWeight: 600, width: '40%' }}>
                          <FormattedMessage id="priority" defaultMessage="Prioridade" />
                        </TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>{labelService}</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>{labelSolution}</TableCell>
                        <TableCell sx={{ width: 52 }} />
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {items.map(item => (
                        <TableRow key={item.priorityid} hover>
                          <TableCell>
                            <Chip
                              label={item.priorityname}
                              size="small"
                              sx={{
                                backgroundColor: item.prioritycolorhex || '#9e9e9e',
                                color: '#fff',
                                fontWeight: 500,
                                fontSize: '0.75rem',
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              type="number"
                              variant="outlined"
                              size="small"
                              value={item.servicetime}
                              onChange={e => this.handleItemChange(item.priorityid, 'servicetime', e.target.value)}
                              inputProps={{ min: 0, step: 1 }}
                              sx={{ width: 130 }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              type="number"
                              variant="outlined"
                              size="small"
                              value={item.solutiontime}
                              onChange={e => this.handleItemChange(item.priorityid, 'solutiontime', e.target.value)}
                              inputProps={{ min: 0, step: 1 }}
                              sx={{ width: 130 }}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => this.handleRequestDelete(item.priorityid)}
                              title={intl.formatMessage({ id: 'delete', defaultMessage: 'Remover' })}
                            >
                              <Delete fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}

              {hasAvailable && (
                <>
                  {items.length > 0 && <Divider />}
                  <Box sx={{ px: 3, py: 2 }}>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12} sm={5}>
                        <SimpleSelectWithColor
                          label={intl.formatMessage({ id: 'priority', defaultMessage: 'Prioridade' })}
                          options={availablePriorities}
                          stateName="selectedPriorityId"
                          changeSelect={this.handlePriorityChange}
                          selected={selectedPriorityId}
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField
                          fullWidth
                          type="number"
                          variant="outlined"
                          label={labelService}
                          value={newServiceTime}
                          onChange={e => this.setState({ newServiceTime: e.target.value })}
                          inputProps={{ min: 0, step: 1 }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField
                          fullWidth
                          type="number"
                          variant="outlined"
                          label={labelSolution}
                          value={newSolutionTime}
                          onChange={e => this.setState({ newSolutionTime: e.target.value })}
                          inputProps={{ min: 0, step: 1 }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={1} sx={{ display: 'flex', alignItems: 'center' }}>
                        <IconButton
                          onClick={this.handleAdd}
                          disabled={!canAdd}
                          title={intl.formatMessage({ id: 'add', defaultMessage: 'Adicionar' })}
                          sx={{
                            backgroundColor: canAdd ? 'primary.main' : 'grey.300',
                            color: '#fff',
                            '&:hover': { backgroundColor: 'primary.dark' },
                            '&.Mui-disabled': { backgroundColor: 'grey.300', color: 'grey.500' },
                          }}
                        >
                          <Add />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Box>
                </>
              )}
            </>
          )}
          </AccordionDetails>
        </Accordion>

        <Dialog
          open={confirmDeleteId !== null}
          onClose={() => this.setState({ confirmDeleteId: null })}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>
            <FormattedMessage id="confirm.delete" defaultMessage="Confirmar exclusão" />
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <FormattedMessage
                id="sla.priority.config.confirm.delete"
                defaultMessage="Deseja remover o SLA da prioridade {name}? Ela passará a utilizar o SLA padrão."
                values={{ name: <strong>{itemToDelete?.priorityname}</strong> }}
              />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ confirmDeleteId: null })} color="primary">
              <FormattedMessage id="no" defaultMessage="Não" />
            </Button>
            <Button onClick={this.handleConfirmDelete} color="error" variant="contained">
              <FormattedMessage id="yes" defaultMessage="Sim" />
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

SlaPriorityConfig.propTypes = {
  intl: PropTypes.object.isRequired,
  slaMode: PropTypes.number.isRequired,
  parentId: PropTypes.number,
  fallbackParentId: PropTypes.number,
  fallbackSlaMode: PropTypes.number,
  defaultServiceTime: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  defaultSolutionTime: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onItemsChange: PropTypes.func,
};

SlaPriorityConfig.defaultProps = {
  parentId: null,
  fallbackParentId: null,
  fallbackSlaMode: null,
  defaultServiceTime: '',
  defaultSolutionTime: '',
};

export default injectIntl(SlaPriorityConfig);
